/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const highlightedItemSchema = z.object({
	product: z.uuid().nullish(),
	image_link: z.string().nullable(),
	video_link: z.string().nullable(),
});
